// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import PublicUtil from './common/js/install'
import axios from './axios/install'
import vuePrint from 'vue-print-nb'
import qs from 'qs'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/jsmind.css'
import './styles/index.less'
import './styles/iconfont.css'
import 'babel-polyfill' // 支持ie浏览器打开
import 'jquery'

import { Message } from 'element-ui';
import { services } from '@/service';
import reporter from './reporter';
import { projectInfoConfig } from '@/constant';

import { dateFilter, timeStrFilter, moneyFilter, timeFilter, phoneFilter } from './filter'
// import VueGridLayout from 'vue-grid-layout'
// import { clickoutside } from './directive'

import infiniteScroll from "vue-infinite-scroll";
import './crashListener'
Vue.use(infiniteScroll);

// Vue.use(VueGridLayout)
Vue.use(ElementUI)
  // 安装共用方法
Vue.use(PublicUtil)
Vue.use(axios)
  /**
   * 导出pdf
   */
Vue.use(vuePrint)

Vue.prototype.$error = function(options) {
  let errMsg = '';
  if (typeof options === 'string') {
    errMsg = options;
  } else {
    errMsg = options.message || '此处报错';
  }

  if (errMsg === '请填写用户信息') {
    return;
  }

  console.error(options);

  if (errMsg.includes('会话已过期')) {
    ElementUI.Message.warning(errMsg);
  } else {
    if (errMsg.includes("Cannot read property 'refresh' of undefined")) {
      console.log('日志上报');
      return;
    }
    ElementUI.Message.error(errMsg);
  }
};

Vue.config.productionTip = false;

Vue.config.errorHandler = function(err) {
  reporter.log({ message: err.stack || err.message });
  console.error(err);
};

window.addEventListener('unhandledrejection', event => {
  reporter.log({ message: event.reason.stack || event.reason.message });
  console.error(event.reason);
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.filter('date-filter', dateFilter);
Vue.filter('timestr-filter', timeStrFilter);
Vue.filter('money-filter', moneyFilter);
Vue.filter('time-filter', timeFilter)
Vue.filter('phone-filter', phoneFilter);

Vue.filter('dateFilter', dateFilter);
Vue.filter('timeStrFilter', timeStrFilter);
Vue.filter('moneyFilter', moneyFilter);
Vue.filter('timeFilter', timeFilter)
Vue.filter('phoneFilter', phoneFilter);



router.beforeEach((to, from, next) => {
  let documentTitle = '小包公智能断案';
  if (to.meta && to.meta.documentTitle) {
    documentTitle = to.meta.documentTitle;
  }
  if (!projectInfoConfig.isDefault && documentTitle.indexOf('小包公') === 0) {
    documentTitle = documentTitle.slice(3);
  }
  document.title = documentTitle;
  next();
});

router.beforeEach((to, from, next) => {
  if (store.getters.isThird && !to.meta.isThird) {
    let nextPath = '/main/search'
    if (from.path.split('/')[1] === 'case') {
      nextPath = '/case/search';
    }
    next({ path: nextPath });
    return;
  }
  next();
});

router.beforeEach((to, from, next) => {
  window.sessionStorage.removeItem('paragraphId')
  window.localStorage.setItem('refreshPageTime', Date.now())
  let identifyFlag = to.query.identifyFlag ? to.query.identifyFlag : window.sessionStorage.getItem('identifyFlag');
  let identifyKey = to.query.identifyKey ? to.query.identifyKey : window.sessionStorage.getItem('identifyKey');
  if (identifyKey && identifyFlag) {
    window.version = 'guangdianzhongda';
  }

  var locationHref = window.location.href;

  console.log('getQueryString', getQueryString('key'), locationHref);
  if (getQueryString('key') && locationHref.indexOf('/index.html') == -1) {
    window.sessionStorage.setItem('regUrlkey', getQueryString('key'))
  }

  if (to.path == '/law/full/text' && from.path == '/law/clause') {
    window.sessionStorage.setItem('paragraphId', from.query.id)
  }
  if (window.version == 'procuratorate' || window.version == 'guangdianzhongda') {
    next()
  } else if (window.version == 'localversion') {
    let token = window.localStorage.getItem('token')
    if (to.path == '/wechat/login' || to.path == '/main/home' || to.query.export_token) {
      next()
    } else if (!token) {
      Message({
        message: '您尚未登录或者您的登录状态已过期，请重新登录',
        type: 'warning'
      })
      window.location.href = locationHref.slice(0, locationHref.indexOf('/home.html')) + '/index.html'
      if (window.location.href.indexOf('localhost') !== -1) {
        router.replace({ path: '/main/home' });
      }
      return;
    } else {
      next()
    }
  } else {
    let token = window.localStorage.getItem('token');
    if (to.path == '/forecast/dashboard') {
      next()
    } else if (!token) {
      Message({
        message: '您尚未登录或者您的登录状态已过期，请重新登录',
        type: 'warning'
      })
      router.replace({ path: '/forecast/dashboard' });
      return;
    } else {
      next()
    }
  }

})

const firstTime = Date.now();
let preTime = firstTime;
let preRoutePath = '';
router.afterEach((to, from) => {
  if (preRoutePath !== to.path) {
    preRoutePath = to.path;
    let nowTime = Date.now();
    const duration = nowTime - preTime;
    preTime = nowTime;
    services.logger.routerLog({
      to: { path: to.path, query: to.query },
      from: from ? { path: from.path, query: from.query } : {},
      firstTime,
      nowTime,
      duration,
      token: window.localStorage.getItem("token")
    });
  }
});

Vue.prototype.Bus = new Vue()

const casePicker = sessionStorage.getItem('casePicker');
if (casePicker) {
  store.dispatch('setCasePicker', JSON.parse(casePicker));
}
window.addEventListener('storage', event => {
  if (event.key === 'casePickerSync' && event.newValue) {
    store.dispatch('setCasePicker', JSON.parse(event.newValue));
  }
});

async function getToken(identifyFlag, identifyKey) {
  let params = {
    identifyFlag: identifyFlag,
    identifyKey: identifyKey.replace(/(^\s+)|(\s+$)|\s+/g, '+'),
    regUrl: decodeURIComponent(window.location.href).replace(/(^\s+)|(\s+$)|\s+/g, '+')
  }
  const data = await services.courseware.postExternalLogin(params)
  if (!data) {
    alert('token不存在')
    return false;
  }
  window.localStorage.setItem('token', data)
  renderVue();
}

if (getQueryString('identifyFlag') && getQueryString('identifyKey')) {
  window.sessionStorage.setItem('identifyFlag', getQueryString('identifyFlag'))
  window.sessionStorage.setItem('identifyKey', getQueryString('identifyKey'))
  getToken(getQueryString('identifyFlag'), getQueryString('identifyKey'));
} else {
  renderVue();
}

function renderVue() {
  if (!projectInfoConfig) {
    Message.warning('当前链接异常，请联系客服及开发人员。');
    return;
  }
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var num=window.location.href.indexOf("?")
  var str=window.location.href.substr(num+1); 
  var r = str.match(reg);
  if (r != null) return unescape(r[2]); return null;
}


// WEBPACK FOOTER //
// ./src/main.js